$(function () {
    $(".js-page-top").click(function () {
        $('html,body').animate({scrollTop: 0}, 'slow');
    });

    $Lead_PostalCode = $("#Lead_PostalCode");
    $(".js-auto-insert-address").click(function () {
        if ($Lead_PostalCode[0]) {
            hyphenRemove($Lead_PostalCode);
            return AjaxZip3.zip2addr($Lead_PostalCode[0], '', 'Lead_Pref', 'Lead_City', 'Lead_Street');
        }
        if ($("#Account_BillingPostalCode")[0]) {
            hyphenRemove($("#Account_BillingPostalCode"));
            return AjaxZip3.zip2addr($("#Account_BillingPostalCode")[0], '', 'Account_BillingState', 'Account_BillingCity', 'Account_BillingStreet');
        }
    });

    $(".js-to-half-width").blur(function () {
        var value = $(this).val();
        $(this).val(toHalfWidth(value));
    })

    function toHalfWidth(value) {
        // 半角変換
        var halfVal = value.replace(/[！-～]/g,
            function( tmpStr ) {
                // 文字コードをシフト
                return String.fromCharCode( tmpStr.charCodeAt(0) - 0xFEE0 );
            }
        );

        // 文字コードシフトで対応できない文字の変換
        return halfVal.replace(/”/g, "\"")
            .replace(/’/g, "'")
            .replace(/‘/g, "`")
            .replace(/￥/g, "\\")
            .replace(/　/g, " ")
            .replace(/〜/g, "~");
    }

    //データ表示出しわけ
    //説明会申し込み 説明会の選択
    showSelectCheck($(".js-select-data-show-seminar__c"), "2");
    $(".js-select-data-show-seminar__c").change(function () {
        showSelectCheck($(this), 2)
    });

    //説明会申し込み お子さまが病気などで保育園に預けられない時、現在はどのような対応をとられていますか？（複数回答可）
    $(".js-checkbox-data-show-other-Field186__c").find("input").each(function () {
        showCheckboxCheck($(this));
    });
    $(".js-checkbox-data-show-other-Field186__c").find("input").change(function () {
        showCheckboxCheck($(this));
    });

    //説明会申し込み お子さまが年齢・同居されているご家族構成を教えてください(複数回答可)
    $(".js-checkbox-data-show-other-babyage__c").find("input").each(function () {
        showCheckboxCheck($(this));
    });
    $(".js-checkbox-data-show-other-babyage__c").find("input").change(function () {
        showCheckboxCheck($(this));
    });

    //説明会申し込み 当日のお子様の同伴について
    showSelectCheck($(".js-select-data-show-takuji__c"), "1");
    $(".js-select-data-show-takuji__c").change(function () {
        showSelectCheck($(this), "1");
    });

    //問診チェック 予約会員
    $(".js-checkbox-data-show-yoyaku_kibou__c").find("input").each(function () {
        switchYoyakuField($(this));
    });
    $(".js-checkbox-data-show-yoyaku_kibou__c").find("input").change(function () {
        switchYoyakuField($(this));
    });

    //予約チェック確認
    function switchYoyakuField(element) {
        $self = element;
        //チェックが入ったら、利用開始希望日を表示し、問診部分を非表示にする
        if ($self.is(':checked')) {
            //利用開始希望日、表示
            $("[data-show-if=yoyaku_kibou__c]").show();
            //問診、非表示
			_hideTarget('yoyaku_kibou__c_other');

        } else {
            //利用開始希望日、非表示
			_hideTarget('yoyaku_kibou__c');
            //問診、表示
            $("[data-show-if=yoyaku_kibou__c_other]").show();
        }
    }

    //問診チェック ご利用希望パック
    showSelectCheck_nyukaiPack($(".js-checkbox-data-show-contact_nyukaiPack__c"));
    $(".js-checkbox-data-show-contact_nyukaiPack__c").change(function () {
        showSelectCheck_nyukaiPack($(this))
    });
    //セレクトボタン
    function showSelectCheck_nyukaiPack(element) {
        $self = element;
        var val = $self.val();
        var id = $self.attr("id");
        var target = id + '_value_show';
        if (val == '行政パック') {
            $("[data-show-if=" + target + "_2]").show();
            _hideTarget(target + "_3");
        } else if (val == '法人パック') {
            $("[data-show-if=" + target + "_3]").show();
            _hideTarget(target + "_2");
            _hideTarget("gyoseipacki_shurui__c_value_show"); //世帯の情報
        } else {
			_hideTarget(target + "_2");
			_hideTarget(target + "_3");
			_hideTarget("gyoseipacki_shurui__c_value_show"); //世帯の情報
        }
    }

	//問診チェック 世帯の情報
	showSelectCheck($(".js-checkbox-data-show-gyoseipacki_shurui__c"), '淀川区');
	$(".js-checkbox-data-show-gyoseipacki_shurui__c").change(function () {
		showSelectCheck($(this), '淀川区');
	});
  
  //add 171220 ogino 保育場所②
    //問診チェック 保育施設
    showSelectCheck($(".js-select-data-show-contact_hoikuShisetsu__c"), '自宅以外');
    $(".js-select-data-show-contact_hoikuShisetsu__c").change(function () {
        showSelectCheck($(this), '自宅以外');
    });
  //end
    
  //add 180925 ogino SP寄付対応
    //問診チェック SPニースオプション
    $(".js-checkbox-data-show-hattatsu_syougai__c").find("input").each(function () {
        showCheckboxCheck($(this));
    });
    $(".js-checkbox-data-show-hattatsu_syougai__c").find("input").change(function () {
        showCheckboxCheck($(this));
    });
    
    //問診チェック 発達検査の受診？ある場合は詳細をお書きください
    showSelectCheck_datavalue($(".js-select-data-show-hattatsu_kensajyusin__c"));
    $(".js-select-data-show-hattatsu_kensajyusin__c").change(function () {
        showSelectCheck_datavalue($(this));
    });
  //end

    //問診チェック ノーベルクーポン
    $(".js-checkbox-data-show-syoukai_coupon").find("input").each(function () {
        showCheckboxCheck($(this));
    });
    $(".js-checkbox-data-show-syoukai_coupon").find("input").change(function () {
        showCheckboxCheck($(this));
    });

    //問診チェック お父様の喫煙経験
    showSelectCheck_datavalue($(".js-select-data-show-Field38__c"));
    $(".js-select-data-show-Field38__c").change(function () {
        showSelectCheck_datavalue($(this));
    });

    //問診チェック お母様の喫煙経験
    showSelectCheck_datavalue($(".js-select-data-show-Field39__c"));
    $(".js-select-data-show-Field39__c").change(function () {
        showSelectCheck_datavalue($(this));
    });

    //問診チェック 出生時の異常はありましたか？ある場合は詳細をお書きください
    showSelectCheck_datavalue($(".js-select-data-show-Field96__c"));
    $(".js-select-data-show-Field96__c").change(function () {
        showSelectCheck_datavalue($(this));
    });

    //問診チェック 乳幼児健康診査において、要指導要観察を受けたことがありますか？
    showSelectCheck_datavalue($(".js-select-data-show-Field98__c"));
    $(".js-select-data-show-Field98__c").change(function () {
        showSelectCheck_datavalue($(this));
    });

    //問診チェック 喘息と診断されたことはありますか？
    showSelectCheck_datavalue($(".js-select-data-show-Field100__c"));
    $(".js-select-data-show-Field100__c").change(function () {
        showSelectCheck_datavalue($(this));
    });

    //問診チェック その他よく通院する特定の病気はありますか？
    showSelectCheck_datavalue($(".js-select-data-show-Field119__c"));
    $(".js-select-data-show-Field119__c").change(function () {
        showSelectCheck_datavalue($(this));
    });

    //問診チェック 特別な医療行為を必要とする病気はありますか？
    showSelectCheck_datavalue($(".js-select-data-show-Field121__c"));
    $(".js-select-data-show-Field121__c").change(function () {
        showSelectCheck_datavalue($(this));
    });

    //問診チェック 継続して内服している薬はありますか？
    showSelectCheck_datavalue($(".js-select-data-show-Field127__c"));
    $(".js-select-data-show-Field127__c").change(function () {
        showSelectCheck_datavalue($(this));
    });

    //問診チェック 薬物アレルギーはありますか？
    showSelectCheck_datavalue($(".js-select-data-show-Field112__c"));
    $(".js-select-data-show-Field112__c").change(function () {
        showSelectCheck_datavalue($(this));
    });

    //問診チェック 食物・動物アレルギーはありますか？
    showSelectCheck_datavalue($(".js-select-data-show-Field114__c"));
    $(".js-select-data-show-Field114__c").change(function () {
        showSelectCheck_datavalue($(this));
    });

    //問診チェック エピペンを処方されていますか？
    showSelectCheck_datavalue($(".js-select-data-show-Field124__c"));
    $(".js-select-data-show-Field124__c").change(function () {
        showSelectCheck_datavalue($(this));
    });

    //問診チェック アトピー性皮膚炎と診断をうけられたことがありますか？
    showSelectCheck_datavalue($(".js-select-data-show-Field128__c"));
    $(".js-select-data-show-Field128__c").change(function () {
        showSelectCheck_datavalue($(this));
    });

    //問診チェック お子さまは痙攣を起こしたことがありますか？
    showSelectCheck_datavalue($(".js-select-data-show-Field107__c"));
    $(".js-select-data-show-Field107__c").change(function () {
        showSelectCheck_datavalue($(this));
        showSelectCheck_datavalue($(".js-select-data-show-Field109__c"));
    });

    //問診チェック 受診の有無
    showSelectCheck_datavalue($(".js-select-data-show-Field109__c"));
    $(".js-select-data-show-Field109__c").change(function () {
        showSelectCheck_datavalue($(this));
    });

    //問診チェック お子さまは入院されたことはありますか？
    showSelectCheck_datavalue($(".js-select-data-show-Field129__c"));
    $(".js-select-data-show-Field129__c").change(function () {
        showSelectCheck_datavalue($(this));
    });

    //問診チェック 特別な支援が必要な事故後遺症はありますか？
    showSelectCheck_datavalue($(".js-select-data-show-contact_umuZiko__c"));
    $(".js-select-data-show-contact_umuZiko__c").change(function () {
        showSelectCheck_datavalue($(this));
    });
  
  //add ogino 191115 スペシャルニーズ保育の問診票
    //問診チェック 定期的に通う医療機関
    showSelectCheck($(".js-select-data-show-hattatsu_kikan"), 'はい');
    $(".js-select-data-show-hattatsu_kikan").change(function () {
        showSelectCheck($(this), 'はい');
    });
    
    //問診チェック 食事・水分補給時の援助
    showSelectCheck($(".js-select-data-show-hattatsu_mealhelp"), '必要');
    $(".js-select-data-show-hattatsu_mealhelp").change(function () {
        showSelectCheck($(this), '必要');
    });
    
    //問診チェック 排泄時の援助
    showSelectCheck($(".js-select-data-show-hattatsu_haisetsu"), '必要');
    $(".js-select-data-show-hattatsu_haisetsu").change(function () {
        showSelectCheck($(this), '必要');
    });
    
    //問診チェック 着替え時の援助
    showSelectCheck($(".js-select-data-show-hattatsu_kigae"), '必要');
    $(".js-select-data-show-hattatsu_kigae").change(function () {
        showSelectCheck($(this), '必要');
    });
    
    //問診チェック 睡眠時（就寝時・お目覚め時）の援助
    showSelectCheck($(".js-select-data-show-hattatsu_suimin"), '必要');
    $(".js-select-data-show-hattatsu_suimin").change(function () {
        showSelectCheck($(this), '必要');
    });
    
    //問診チェック 視覚支援
    showSelectCheck($(".js-select-data-show-hattatsu_shikakushien"), '必要');
    $(".js-select-data-show-hattatsu_shikakushien").change(function () {
        showSelectCheck($(this), '必要');
    });
    
    //問診チェック 人見知り（初対面の人）や、場所見知り
    showSelectCheck_shyness($(".js-select-data-show-hattatsu_shyness"));
    $(".js-select-data-show-hattatsu_shyness").change(function () {
        showSelectCheck_shyness($(this));
    });
    
    //問診チェック 感覚過敏
    showSelectCheck($(".js-select-data-show-hattatsu_kankakukabin"), 'あり');
    $(".js-select-data-show-hattatsu_kankakukabin").change(function () {
        showSelectCheck($(this), 'あり');
    });
    
    //問診チェック パニック
    showSelectCheck($(".js-select-data-show-hattatsu_panic"), 'あり');
    $(".js-select-data-show-hattatsu_panic").change(function () {
        showSelectCheck($(this), 'あり');
    });

    function showSelectCheck_shyness(element) {
        $self = element;
        var val = $self.val();
        var id = $self.attr("id");
        var target = id + '_value_show';
        var value1 = 'なし';
        var value2 = '';

        if ((val == value1) || (val == value2)) {
            $("[data-show-if=" + target + "]").hide();
            $("[data-show-if=" + target + "]").map(function () {
                $(this).find("input:text").val("");
				$(this).find("input[type=tel]").val("");
				$(this).find("input[type=email]").val("");
                $(this).find("input:checkbox").prop('checked', false);
                $(this).find("select").val("");
                $(this).find("textarea").val("");
            });
        } else {
            $("[data-show-if=" + target + "]").show();
        }
    }
  //end

    //支払い方法 支払い方法の選択
    showSelectText($(".js-select-data-show-account_kessaiType__c"));
    $(".js-select-data-show-account_kessaiType__c").change(function () {
        showSelectText($(this));
    });

    function showSelectText(element) {
        $self = element;
        var val = $self.val();
        if (val == 'クレジットカード') {
            $("[data-show-if='account_kessaiType__c_bank_show']").hide();
            $("[data-show-if='account_kessaiType__c_credit_show']").show();
        } else if (val == '銀行口振') {
            $("[data-show-if='account_kessaiType__c_bank_show']").show();
            $("[data-show-if='account_kessaiType__c_credit_show']").hide();
        } else {
            $("[data-show-if='account_kessaiType__c_bank_show']").hide();
            $("[data-show-if='account_kessaiType__c_credit_show']").hide();
        }
    }


    //アンケート 検討結果について
    showSelectCheckX4__c($(".js-select-data-show-X4__c"));
    $(".js-select-data-show-X4__c").change(function () {
        showSelectCheckX4__c($(this));
    });

	function showSelectCheckX4__c(element) {
		var $self = element;
		var val = $self.val();

		if (val == "1" || val == "2") {
			$("[data-show-if='X4__c__is_1_2']").show();
			if (val == "2") {
				$("[data-show-if='X4__c__is_2']").show();
			} else {
				_hideTarget('X4__c__is_2');
			}
		} else {
			_hideTarget('X4__c__is_1_2');
			_hideTarget('X4__c__is_2');
		}

		//各パックの出し分け
		if(val == '1'){
            //change ogino 180517 基本パックの選択追加
			//ひとり親
			if(!$("#read_houzinKibou__c").prop('checked') || !$("#yodogawapack__c").prop('checked') || !$("#nobelpack__c").prop('checked')) {
				$("[data-show-if='hitoriokan_check']").show();
			}
			//法人
			if(!$("#hitoriokan__c").prop('checked') || !$("#yodogawapack__c").prop('checked') || !$("#nobelpack__c").prop('checked')) {
				$("[data-show-if='houzin_check']").show();
			}
			//行政
			if(!$("#read_houzinKibou__c").prop('checked') || !$("#hitoriokan__c").prop('checked') || !$("#nobelpack__c").prop('checked')) {
				$("[data-show-if='gyousei_check']").show();
			}
            //end
            //add ogino 180517 基本
            //基本
            if(!$("#read_houzinKibou__c").prop('checked') || !$("#hitoriokan__c").prop('checked') || !$("#yodogawapack__c").prop('checked')) {
                $("[data-show-if='nobel_check']").show();
            }
            $("[data-show-if='plan_select']").show();
            //end
		}else{
			//ひとり親
			_hideTarget('hitoriokan_check');
			_hideTarget('hitoriokan__c');
			//法人
			_hideTarget('houzin_check');
			_hideTarget('read_houzinKibou__c');
			//行政
			_hideTarget('gyousei_check');
			_hideTarget('yodogawapack__c');
			_hideTarget('gyosei_shurui__c_value_show');
            //add ogino 180517 基本パック
            //基本
            _hideTarget('nobel_check');
            _hideTarget('nobelpack__c');
  
            _hideTarget('plan_select');
            //end
		}
	}

    //アンケート ひとり親パック入会希望について
    $(".js-select-data-show-hitoriokan__c").find("input").each(function () {
		packCheckboxControll($(this), 'hitori');
    });
    $(".js-select-data-show-hitoriokan__c").find("input").change(function () {
		packCheckboxControll($(this), 'hitori');
    });

	//アンケート 法人パックでのご入会をご希望の方はチェックしてください
	$(".js-select-data-show-houjin_type__c").find("input").each(function () {
		packCheckboxControll($(this), 'houjin');
	});
	$(".js-select-data-show-houjin_type__c").find("input").change(function () {
		packCheckboxControll($(this), 'houjin');
	});

	//アンケート 行政パックでのご入会をご希望の方はチェックしてください
	$(".js-select-data-show-gyosei_shurui__c").find("input").each(function () {
		packCheckboxControll($(this), 'gyousei');
	});
	$(".js-select-data-show-gyosei_shurui__c").find("input").change(function () {
		packCheckboxControll($(this), 'gyousei');
	});
  
    //add ogino 180517 基本パック
    //アンケート 基本パックでのご入会をご希望の方はチェックしてください
    $(".js-select-data-show-nobel__c").find("input").each(function () {
        packCheckboxControll($(this), 'nobel');
    });
    $(".js-select-data-show-nobel__c").find("input").change(function () {
        packCheckboxControll($(this), 'nobel');
    });
    //end

    function packCheckboxControll(element, type){
		$self = element;
		var val = $self.val();
		if (val) {
			var target = $self.attr("id");
			if ($self.is(':checked')) {
				$("[data-show-if=" + target + "]").show();
				///消す
                //change ogino 180517 基本パックチェックボックス追加対応
				//ひとり親を消す
				if(type == 'houjin' || type == 'gyousei' || type == 'nobel'){
					_hideTarget('hitoriokan_check');
					_hideTarget('hitoriokan__c');
				}
				//法人を消す
				if(type == 'hitori' || type == 'gyousei' || type == 'nobel'){
					_hideTarget("read_houzinKibou__c");
					_hideTarget("houzin_check");
				}
				//行政を消す
				if(type == 'hitori' || type == 'houjin' || type == 'nobel'){
					_hideTarget('gyousei_check');
					_hideTarget('yodogawapack__c');
					_hideTarget('gyosei_shurui__c_value_show');
				}
                //end
                //add ogino 180517 基本パック
                //基本パックを消す
                if(type == 'houjin' || type == 'gyousei' || type == 'hitori'){
                    _hideTarget('nobel_check');
                }
                //end
			} else {
				_hideTarget(target);
				//行政パックのチェックが外れたら世帯の情報も消す
				if(target == 'yodogawapack__c') _hideTarget('gyosei_shurui__c_value_show');
				///出す
				if($(".js-select-data-show-X4__c").val() == "1") {
                    //change ogino 180517 基本パックチェックボックス追加対応
					if(!$("#hitoriokan__c").prop('checked') && !$("#read_houzinKibou__c").prop('checked') && !$("#yodogawapack__c").prop('checked') && !$("#nobelpack__c").prop('checked')) {
						//全部にチェックがなかったら出す
						$("[data-show-if=hitoriokan_check]").show();
						$("[data-show-if=houzin_check]").show();
						$("[data-show-if=gyousei_check]").show();
                        $("[data-show-if=nobel_check]").show();
					}
                    //end
				}
			}
		}
	}

	//アンケート 世帯の情報
	showSelectCheck_genmen($(".js-select-data-show-read_gyoseiGenmen__c"), "淀川区", "gyosei_shurui__c_value_show");
	$(".js-select-data-show-read_gyoseiGenmen__c").change(function () {
		showSelectCheck_genmen($(this), '淀川区', "gyosei_shurui__c_value_show");
	});
	//セレクトボタン
	function showSelectCheck_genmen(element, value, hide_class) {
		$self = element;
		var val = $self.val();
		var id = $self.attr("id");
		var target = id + '_value_show';
		if (val == value) {
			$("[data-show-if=" + target + "]").show();
		} else {
			_hideTarget(target);
			_hideTarget(hide_class);
		}
	}

	//ひとり親パックのチェックボックス
	/*function hitoriokanCheckboxCheck(element) {
		$self = element;
		var val = $self.val();
		if (val) {
			var target = $self.attr("id");
			if ($self.is(':checked')) {
				$("[data-show-if=" + target + "]").show();
				//法人パック
				_hideTarget("read_houzinKibou__c");
				_hideTarget("houzin_check");

			} else {
				_hideTarget(target);

				//法人パックを出す
				if($(".js-select-data-show-X4__c").val() == "1" || $(".js-select-data-show-X4__c").val() == "2") {
					$("[data-show-if=houzin_check]").show();
				}
			}
		}
	}*/

	//法人パックのチェックボックス
	/*function houjinCheckboxCheck(element) {
		$self = element;
		var val = $self.val();
		if (val) {
			var target = $self.attr("id");
			if ($self.is(':checked')) {
				$("[data-show-if=" + target + "]").show();
				//ひとり親パックの順番意向を消す
				_hideTarget("hitoriokan__c");
				//ひとり親パックのチェックを消す
				_hideTarget("hitoriokan_check");

			} else {
				_hideTarget(target);

				//ひとり親パックを出す
				if($(".js-select-data-show-X4__c").val() == "1") {
					$("[data-show-if=hitoriokan_check]").show();
				}
			}
		}
	}*/

	//表示を消し、そのdiv以下のフォームを空にする
	function _hideTarget(target){
		$("[data-show-if="+ target + "]").hide();
		$("[data-show-if=" + target + "]").map(function () {
			$(this).find("input:text").val("");
			$(this).find("input[type=tel]").val("");
			$(this).find("input[type=email]").val("");
			$(this).find("input:checkbox").prop('checked', false);
			$(this).find("select").val("");
			$(this).find("textarea").val("");
		});
	}

	//情報登録 子どもの血液型
	showSelectCheck_datavalue($(".js-select-data-show-Field91__c"));
	$(".js-select-data-show-Field91__c").change(function () {
		showSelectCheck_datavalue($(this));
	});

    //情報登録 保育園・学校
    $(".js-checkbox-data-hide-Field170__c").find("input").each(function () {
        hideCheckboxCheck($(this));
    });
    $(".js-checkbox-data-hide-Field170__c").find("input").change(function () {
        hideCheckboxCheck($(this));
    });

    //情報登録 かかりつけ医①
    $(".js-checkbox-data-hide-Fieldkakaritsuke__c_1").find("input").each(function () {
        hideCheckboxCheck($(this));
    });
    $(".js-checkbox-data-hide-Fieldkakaritsuke__c_1").find("input").change(function () {
        hideCheckboxCheck($(this));
    });


    //情報登録 かかりつけ医②
    $(".js-checkbox-data-hide-Fieldkakaritsuke__c_2").find("input").each(function () {
        hideCheckboxCheck($(this));
    });
    $(".js-checkbox-data-hide-Fieldkakaritsuke__c_2").find("input").change(function () {
        hideCheckboxCheck($(this));
    });
  
  //add ogino 180119 保育場所②
    //情報登録 保育場所②かかりつけ医①
    $(".js-checkbox-data-hide-FieldkakaritsukeHoShi__c_1").find("input").each(function () {
        hideCheckboxCheck($(this));
    });
    $(".js-checkbox-data-hide-FieldkakaritsukeHoShi__c_1").find("input").change(function () {
        hideCheckboxCheck($(this));
    });
  
    //情報登録 保育場所②かかりつけ医②
    $(".js-checkbox-data-hide-FieldkakaritsukeHoShi__c_2").find("input").each(function () {
        hideCheckboxCheck($(this));
    });
    $(".js-checkbox-data-hide-FieldkakaritsukeHoShi__c_2").find("input").change(function () {
        hideCheckboxCheck($(this));
    });
  
    //情報登録 保育場所②ペットの有無
    $(".js-radio-data-show-contact_hoShiPet__c").find("input").each(function () {
        showRadioDetail($(this), 'contact_hoShiPet__c');
    });
    $(".js-radio-data-show-contact_hoShiPet__c").find("input").change(function () {
        showRadioDetail($(this), 'contact_hoShiPet__c');
    });
  
    //情報登録 保育場所②駐輪場の有無
    $(".js-radio-data-show-contact_hoShiBike__c").find("input").each(function () {
        showRadioDetail($(this), 'contact_hoShiBike__c');
    });
    $(".js-radio-data-show-contact_hoShiBike__c").find("input").change(function () {
        showRadioDetail($(this), 'contact_hoShiBike__c');
    });
  //end

    //情報登録 ペットの有無
    $(".js-radio-data-show-Field53__c").find("input").each(function () {
        showRadioDetail($(this), 'Field53__c');
    });
    $(".js-radio-data-show-Field53__c").find("input").change(function () {
        showRadioDetail($(this), 'Field53__c');
    });

    //情報登録 駐輪場の有無
    $(".js-radio-data-show-Field58__c").find("input").each(function () {
        showRadioDetail($(this), 'Field58__c');
    });
    $(".js-radio-data-show-Field58__c").find("input").change(function () {
        showRadioDetail($(this), 'Field58__c');
    });

    function showRadioDetail(element, $datashow) {
        var $self = element;
        var val = $self.val();
        var checked = $self.prop('checked');

        if (checked && val == 'あり') {
            //出す
            $("[data-show-if='" + $datashow + "']").show();
        } else if (checked && val == 'なし') {
            //消す
            $("[data-show-if='" + $datashow + "']").hide();
            $("[data-show-if='" + $datashow + "']").map(function () {
                $(this).find("input:text").val("");
				$(this).find("input[type=tel]").val("");
				$(this).find("input[type=email]").val("");
            });
        } else {
            //消す
            $("[data-show-if='" + $datashow + "']").hide();
        }
    }

    //問診チェック 提携割引をご利用の方は以下から選択ください。
    showSelectCheckaffiliate_name__c($(".js-select-data-show-affiliate_name__c"), ["1", "2"]);
    $(".js-select-data-show-affiliate_name__c").change(function () {
        showSelectCheckaffiliate_name__c($(this));
    });

    function showSelectCheckaffiliate_name__c(element) {
        var $self = element;
        var val = $self.val();
        if (val != "") {
            $("[data-show-if='affiliate_name']").show();
        } else {
			_hideTarget('affiliate_name');
        }
    }

    //セレクトボタン
    function showSelectCheck(element, value) {
        $self = element;
        var val = $self.val();
        var id = $self.attr("id");
        var target = id + '_value_show';
        if (val == value) {
            $("[data-show-if=" + target + "]").show();
        } else {
            $("[data-show-if=" + target + "]").hide();
            $("[data-show-if=" + target + "]").map(function () {
                $(this).find("input:text").val("");
				$(this).find("input[type=tel]").val("");
				$(this).find("input[type=email]").val("");
                $(this).find("input:checkbox").prop('checked', false);
                $(this).find("select").val("");
                $(this).find("textarea").val("");
            });
        }
    }

    //セレクトボタン - 値をdata-valueから取得
    function showSelectCheck_datavalue(element) {
        $self = element;
        var val = $self.val();
        var id = $self.attr("id");
        var target = id + '_value_show';
        var value = $self.attr('data-value');

        if (val == value) {
            $("[data-show-if=" + target + "]").show();
        } else {
            $("[data-show-if=" + target + "]").hide();
            $("[data-show-if=" + target + "]").map(function () {
                $(this).find("input:text").val("");
				$(this).find("input[type=tel]").val("");
				$(this).find("input[type=email]").val("");
                $(this).find("input:checkbox").prop('checked', false);
                $(this).find("select").val("");
                $(this).find("textarea").val("");
            });
        }
    }

    //チェックボックス
    function showCheckboxCheck(element) {
        // console.log("hoge");
        $self = element;
        var val = $self.val();
        if (val) {
            var target = $self.attr("id");
            if ($self.is(':checked')) {
                $("[data-show-if=" + target + "]").show();
            } else {
                $("[data-show-if=" + target + "]").hide();
                $("[data-show-if=" + target + "]").map(function () {
                    $(this).find("input:text").val("");
					$(this).find("input[type=tel]").val("");
					$(this).find("input[type=email]").val("");
                    $(this).find("input:checkbox").prop('checked', false);
                    $(this).find("select").val("");
                    $(this).find("textarea").val("");
                });
            }
        }
    }

    function hideCheckboxCheck(element) {
        $self = element;
        var val = $self.val();
        if (val) {
            var target = $self.attr("id");
            if ($self.is(':checked')) {
                $("[data-show-if=" + target + "]").hide();
                $("[data-show-if=" + target + "]").map(function () {
                    $(this).find("input:text").val("");
                    $(this).find("input[type=tel]").val("");
                    $(this).find("input[type=email]").val("");
                    $(this).find("input:checkbox").prop('checked', false);
                    $(this).find("select").val("");
                    $(this).find("textarea").val("");
                });
            } else {
                $("[data-show-if=" + target + "]").show();
            }
        }
    }

    //チェックボックス 表示出しわけ
    optionCheck(".js-checkbox-data-show-option-1");//問診チェック ご利用希望パック
    optionCheck(".js-checkbox-data-show-option-2");//提携割引

    function optionCheck(element) {
        $(element).find("input").change(function () {
            var name = $(this).attr("name");
            var target = name;
            var target_contain_other = false;
            $("" + element + " input:checked").each(function () {
                if ($(this).attr("name") == target) return target_contain_other = true;
            });
            if (target_contain_other) {
                $("[data-show-if=" + target + "]").show();
            } else {
                $("[data-show-if=" + target + "]").hide();
                $("[data-show-if=" + target + "]").find("input:text").val("");
                $("[data-show-if=" + target + "]").find("input:checkbox").prop('checked', false);
                $("[data-show-if=" + target + "]").find("select").val("");
                $("[data-show-if=" + target + "]").find("textarea").val("");
            }
        });
    }

    //ハイフン削除
    function hyphenRemove(e) {
        $hyphenA = e.val().replace(/-/g, "");
        e.val($hyphenA)//半角ハイフン
        $hyphenC = e.val().replace(/-/g, "");
        e.val($hyphenC)//半角ハイフンマイナス
        $hyphenB = e.val().replace(/―/g, "");
        e.val($hyphenB)//全角ダッシュ
        $hyphenD = e.val().replace(/ー/g, "");
        e.val($hyphenD)//その他全
        $hyphenE = e.val().replace(/-/g, "");
        e.val($hyphenE)//その他半
        $hyphenF = e.val().replace(/－/g, "");
        e.val($hyphenF)//その他全
        $hyphenG = e.val().replace(/ｰ/g, "");
        e.val($hyphenG)//その他半カタカナ
        $hyphenH = e.val().replace(/‐/g, "");
        e.val($hyphenH)//全角ハイフン
        $hyphenI = e.val().replace(/\u2212/g, "");
        e.val($hyphenI)//全角ハイフンマイナス
    }

    //説明会申し込み エリアチェックまで
    $("#form_saminar_1").validate({
        ignore: ':hidden',
        rules: {
            "Lead_LastName": "required",//保護者氏名(姓)
            "Lead_FirstName": "required",//保護者氏名(名)
            "namaefurigana__c_LastName": "required",//保護者氏名(セイ)
            "namaefurigana__c_FirstName": "required",//保護者氏名(メイ)
            "Email": {required: true, email: true},//メールアドレス
            "Phone": "required",//電話番号
            "Lead_PostalCode": "required",//郵便番号
            "Lead_Pref": "required",//都道府県
            "Lead_City": "required",//市区
            "Lead_Street": "required",//町名番地
        },
        messages: {
            "Lead_LastName": {required: '必須項目です。'},//保護者氏名(姓)
            "Lead_FirstName": {required: '必須項目です。'},//保護者氏名(名)
            "namaefurigana__c_LastName": {required: '必須項目です。'},//保護者氏名(セイ)
            "namaefurigana__c_FirstName": {required: '必須項目です。'},//保護者氏名(メイ)
            "Email": {//メールアドレス
                required: '必須項目です。',
                email: '正しいemail形式で入力してください'
            },
            "Phone": {required: '必須項目です。'},//電話番号
            "Lead_PostalCode": {required: '必須項目です。'},//郵便番号
            "Lead_Pref": {required: '必須項目です。'},//都道府県
            "Lead_City": {required: '必須項目です。'},//市区
            "Lead_Street": {required: '必須項目です。'},//町名番地
        },
        errorClass: "invalid",
        errorElement: 'p',
        errorPlacement: function (error, element) {
            //checkbox
            //複数名での参加について
            if (element.attr("name") == "Field352__c") {
                element.parents("ul").find("li").append("<p id='Field352__c-error' class='invalid'>必須項目です。</p>")
            }
            //お子さまが病気などで保育園に預けられない時、現在はどのような対応をとられていますか？（複数回答可）
            else if (element.attr("name") == "Field186__c") {
                element.parents("ul").find("li:last-of-type").append("<p id='Field186__c-error' class='invalid'>必須項目です。</p>")
            }
            //お子さまが年齢・同居されているご家族構成を教えてください(複数回答可)
            else if (element.attr("name") == "babyage__c") {
                element.parents("ul").find("li:last-of-type").append("<p id='babyage__c-error' class='invalid'>必須項目です。</p>")
            }

            //selectbox
            else if (element.attr("name") == "seminar__c") {
                element.parents("label").after("<p id='seminar__c-error' class='invalid'>必須項目です。</p>")
            } else if (element.attr("name") == "takuji__c") {
                element.parents("label").after("<p id='takuji__c-error' class='invalid'>必須項目です。</p>")
            } else if (element.attr("name") == "Field14__c") {
                element.parents("label").after("<p id='Field14__c-error' class='invalid'>必須項目です。</p>")
            }
            //その他
            else {
                error.insertAfter(element);
            }
        },
        onfocusout: function (element) {
            $(element).valid();
        }
    });

    $("#form_saminar_2").validate({
        //checkbox、radioボタンはidをignoreに入れる必要あり。
        ignore: ':hidden:not("#Field186__c_1,#Field186__c_2,#Field186__c_3,#Field186__c_4,#Field186__c_5,#Field186__c_6,#Field186__c_7,#babyage__c_1,#babyage__c_2,#babyage__c_3,#babyage__c_4,#babyage__c_5,#babyage__c_6,#babyage__c_7,#babyage__c_8,#babyage__c_9,#babyage__c_10,#babyage__c_11,#babyage__c_12")',
        rules: {
            //説明会申し込み
            "LastName": "required",//保護者氏名(姓)
            "FirstName": "required",//保護者氏名(名)
            "namaefurigana__c_LastName": "required",//保護者氏名(セイ)
            "namaefurigana__c_FirstName": "required",//保護者氏名(メイ)
            "Email": {required: true, email: true},//メールアドレス
            "Phone": "required",//電話番号
            "PostalCode": "required",//郵便番号
            "Pref": "required",//都道府県
            "City": "required",//市区
            "Street": "required",//町名番地
            "seminar__c": "required",//説明会の選択
            //"Field168__c": "required",//参加希望日程
            "setsumeikai_annai__c_1": "required",//参加希望日程 西暦
            "setsumeikai_annai__c_2": "required",//参加希望日程 年
            "setsumeikai_annai__c_3": "required",//参加希望日程 月
            "lead_setsumeikaiTime__c": "required",//参加希望日程//時間
            "takuji__c": "required",//当日のお子様の同伴について
            "Field352__c": "required",//複数名での参加について
            "Field186__c[]": "required",//お子さまが病気などで保育園に預けられない時、現在はどのような対応をとられていますか？（複数回答可
            "Field190__c": "required",//その他を選ばれた方は詳しくお教えください。
            "babyage__c[]": "required",//お子さまが年齢・同居されているご家族構成を教えてください(複数回答可)
            //"babyage__c_12": "required",//その他を選ばれた方は詳しくお教えください。
            "Field187__c": "required",//病児保育(ノーベル)の必要性を感じられたきっかけや背景をお聞かせください。
            "Field14__c": "required",//どうやってノーベルをお知りになられましたか？
            "ninchisyoukeirosyousai__c": "required",//どうやってノーベルをお知りになられましたか : 上記を具体的にご記入ください
        },
        messages: {
            "LastName": {required: '必須項目です。'},//保護者氏名(姓)
            "FirstName": {required: '必須項目です。'},//保護者氏名(名)
            "namaefurigana__c_LastName": {required: '必須項目です。'},//保護者氏名(セイ)
            "namaefurigana__c_FirstName": {required: '必須項目です。'},//保護者氏名(メイ)
            "Email": {//メールアドレス
                required: '必須項目です。',
                email: '正しいemail形式で入力してください'
            },
            "Phone": {required: '必須項目です。'},//電話番号
            "PostalCode": {required: '必須項目です。'},//郵便番号
            "Pref": {required: '必須項目です。'},//都道府県
            "City": {required: '必須項目です。'},//市区
            "Street": {required: '必須項目です。'},//町名番地
            "seminar__c": {required: '必須項目です。'},//説明会の選択
            //"Field168__c": {required: '必須項目です。'},//参加希望日程
            "setsumeikai_annai__c_1": {required: '必須項目です。'},//参加希望日程 西暦
            "setsumeikai_annai__c_2": {required: '必須項目です。'},//参加希望日程 年
            "setsumeikai_annai__c_3": {required: '必須項目です。'},//参加希望日程 月
            "lead_setsumeikaiTime__c": {required: '必須項目です。'},//参加希望日程//時間
            "takuji__c": {required: '必須項目です。'},//当日のお子様の同伴について
            "Field352__c": {required: '必須項目です。'},//複数名での参加について
            "Field186__c[]": {required: '必須項目です。'},//お子さまが病気などで保育園に預けられない時、現在はどのような対応をとられていますか？（複数回答可
            "Field190__c": {required: '必須項目です。'},//その他を選ばれた方は詳しくお教えください。
            "babyage__c[]": {required: '必須項目です。'},//お子さまが年齢・同居されているご家族構成を教えてください(複数回答可)
            //"babyage__c_12": {required: '必須項目です。'},//その他を選ばれた方は詳しくお教えください。
            "Field187__c": {required: '必須項目です。'},//病児保育(ノーベル)の必要性を感じられたきっかけや背景をお聞かせください。
            "Field14__c": {required: '必須項目です。'},//どうやってノーベルをお知りになられましたか？
            "ninchisyoukeirosyousai__c": {required: '必須項目です。'},//どうやってノーベルをお知りになられましたか : 上記を具体的にご記入ください
        },
        errorClass: "invalid",
        errorElement: 'p',
        errorPlacement: function (error, element) {
            //checkbox
            //複数名での参加について
            if (element.attr("name") == "Field352__c") {
                element.parents("ul").find("li").append("<p id='Field352__c-error' class='invalid'>必須項目です。</p>")
            }
            //お子さまが病気などで保育園に預けられない時、現在はどのような対応をとられていますか？（複数回答可）
            else if (element.attr("name") == "Field186__c[]") {
                element.parents("ul").find("li:last-of-type").append("<p id='Field186__c[]-error' class='invalid'>必須項目です。</p>")
            }
            //お子さまが年齢・同居されているご家族構成を教えてください(複数回答可)
            else if (element.attr("name") == "babyage__c[]") {
                element.parents("ul").find("li:last-of-type").append("<p id='babyage__c[]-error' class='invalid'>必須項目です。</p>")
            }

            //selectbox
            //説明会の選択
            else if (element.attr("name") == "seminar__c") {
                element.parents("label").after("<p id='seminar__c-error' class='invalid'>必須項目です。</p>")
            }
            //参加希望日程
            else if (element.attr("name") == "seminar__c") {
                element.parents("label").after("<p id='seminar__c-error' class='invalid'>必須項目です。</p>")
            } else if (element.attr("name") == "takuji__c") {
                element.parents("label").after("<p id='takuji__c-error' class='invalid'>必須項目です。</p>")
            } else if (element.attr("name") == "Field14__c") {
                element.parents("label").after("<p id='Field14__c-error' class='invalid'>必須項目です。</p>")
            }
            //どうやってノーベルをお知りになられましたか？
            else if (element.attr("name") == "setsumeikai_annai__c_1") {
                element.parents("label").after("<p id='setsumeikai_annai__c_1-error' class='invalid'>必須項目です。</p>")
            } else if (element.attr("name") == "setsumeikai_annai__c_2") {
                element.parents("label").after("<p id='setsumeikai_annai__c_2-error' class='invalid'>必須項目です。</p>")
            } else if (element.attr("name") == "setsumeikai_annai__c_3") {
                element.parents("label").after("<p id='setsumeikai_annai__c_3-error' class='invalid'>必須項目です。</p>")
            }

            //その他
            else {
                error.insertAfter(element);
            }
        },
        onfocusout: function (element) {
            $(element).valid();
        }
    });

    $("#form_afterseminar").validate({
        //checkbox、radioボタンはidをignoreに入れる必要あり。
        ignore: ':hidden:not("#Field146__c_1,#Field146__c_2,#Field146__c_3,#Field148__c_1,#Field148__c_2,#hitoriokan__c,#read_houzinKibou__c")',
        rules: {
            "Lead_LastName": "required",//お名前 名(姓)
            "Lead_FirstName": "required",//お名前 名(名)
            "Email": {required: true, email: true},//メールアドレス
            "Field146__c": "required",//WEB説明会は全体的にいかがでしたか？
            "Field148__c": "required",//WEB説明会ではほしい情報が得られましたか？
            "X4__c": "required",//検討結果について
            // "hitoriokan__c": "required",//ひとり親パックでのご入会をご希望の方はチェックしてください
            // "houjin_type__c": "required",//検討結果について
            "hitorokanjunban__c": "required", //ひとりおかんっ子パック入会の順番待ちについて
            "houjin_type__c": "required",//法人パックでのご入会をご希望の方は法人を選択してください
            "gyosei_shurui__c": "required",//行政パックでのご入会をご希望の方は行政を選択してください

            "Field365__c": "required",
            "orientation__c_1": "required",
            "orientation__c_2": "required",
            "orientation__c_3": "required",

            "Field28__c_1": "required",
            "Field28__c_2": "required",
            "Field28__c_3": "required",
        },
        messages: {
            "Lead_LastName": {required: '必須項目です。'},//お名前 名(姓)
            "Lead_FirstName": {required: '必須項目です。'},//お名前 名(名)
            "Email": {//メールアドレス
                required: '必須項目です。',
                email: '正しいemail形式で入力してください'
            },
            "Field146__c": {required: '必須項目です。'},//WEB説明会は全体的にいかがでしたか？
            "Field148__c": {required: '必須項目です。'},//WEB説明会ではほしい情報が得られましたか？
            "X4__c": {required: '必須項目です。'},//検討結果について
            // "hitoriokan__c": {required: '必須項目です。'},//ひとり親パックでのご入会をご希望の方はチェックしてください
            "hitorokanjunban__c": {required: '必須項目です。'},//ひとりおかんっ子パック入会の順番待ちについて
            "houjin_type__c": {required: '必須項目です。'},//法人パックでのご入会をご希望の方は法人を選択してください
            "gyosei_shurui__c": {required: '必須項目です。'},//行政パックでのご入会をご希望の方は行政を選択してください

            "Field365__c": {required: '必須項目です。'},
            "orientation__c_1": {required: '必須項目です。'},
            "orientation__c_2": {required: '必須項目です。'},
            "orientation__c_3": {required: '必須項目です。'},

            "Field28__c_1": {required: '必須項目です。'},
            "Field28__c_2": {required: '必須項目です。'},
            "Field28__c_3": {required: '必須項目です。'},
        },
        errorClass: "invalid",
        errorElement: 'p',
        errorPlacement: function (error, element) {
            //radio
            if (element.attr("name") == "Field146__c") {
                element.parents("ul").find("li:first-of-type").append("<p id='Field146__c-error' class='invalid'>必須項目です。</p>")
            }

            else if (element.attr("name") == "Field148__c") {
                element.parents("ul").find("li:first-of-type").append("<p id='Field148__c-error' class='invalid'>必須項目です。</p>")
            }

            //selectbox
            else if (element.attr("name") == "X4__c") {
                element.parents("label").after("<p id='X4__c-error' class='invalid'>必須項目です。</p>")
            }

            else if (element.attr("name") == "hitorokanjunban__c") {
                element.parents("label").after("<p id='hitorokanjunban__c-error' class='invalid'>必須項目です。</p>")
            }

            else if (element.attr("name") == "houjin_type__c") {
                element.parents("label").after("<p id='houjin_type__c-error' class='invalid'>必須項目です。</p>")
            }

			else if (element.attr("name") == "gyosei_shurui__c") {
				element.parents("label").after("<p id='gyosei_shurui__c-error' class='invalid'>必須項目です。</p>")
			}

            else if (element.attr("name") == "orientation__c_1") {
                element.parents("label").after("<p id='orientation__c_1-error' class='invalid'>必須項目です。</p>")
            }
            else if (element.attr("name") == "orientation__c_2") {
                element.parents("label").after("<p id='orientation__c_2-error' class='invalid'>必須項目です。</p>")
            }
            else if (element.attr("name") == "orientation__c_3") {
                element.parents("label").after("<p id='orientation__c_3-error' class='invalid'>必須項目です。</p>")
            }

            else if (element.attr("name") == "Field28__c_1") {
                element.parents("label").after("<p id='Field28__c_1-error' class='invalid'>必須項目です。</p>")
            }
            else if (element.attr("name") == "Field28__c_2") {
                element.parents("label").after("<p id='Field28__c_2-error' class='invalid'>必須項目です。</p>")
            }
            else if (element.attr("name") == "Field28__c_3") {
                element.parents("label").after("<p id='Field28__c_3-error' class='invalid'>必須項目です。</p>")
            }

            //その他
            else {
                error.insertAfter(element);
            }
        },
        onfocusout: function (element) {
            $(element).valid();
        }
    });

    $("#form_register_1").validate({
        //checkbox、radioボタンはidをignoreに入れる必要あり。
        ignore: ':hidden:not("#sex__c_1,#sex__c_2,#yoyaku_kibou__c,#houjin_register__c,#Field130__c_1,#Field130__c_2,#account_douiTei__c")',
        rules: {
            "Account_Name": "required",//保護者の名前
            //"FirstName": "required",//保護者氏名(名)
            "Contact_LastName": "required",//お子さまの名前(姓)
            "Contact_FirstName": "required",//お子さまの名前(名)
            "furigana2__c_LastName": "required",//お子さまのフリガナ(セイ)
            "furigana2__c_FirstName": "required",//お子さまのフリガナ(メイ)
            "sex__c": "required",//お子さまの性別
            "birthday__c_1": "required",//お子さまの生年月日 西暦
            "birthday__c_2": "required",//お子さまの生年月日 月
            "birthday__c_3": "required",//お子さまの生年月日 日
            "Email": {required: true, email: true},//メールアドレス
            "Account_BillingPostalCode": "required",//郵便番号
            "Account_BillingState": "required",//都道府県
            "Account_BillingCity": "required",//市区郡
            "Account_BillingStreet": "required",//町名以下
            "Field8__c_1": "required",//入会希望日 西暦
            "Field8__c_2": "required",//入会希望日 月
            "Field8__c_3": "required",//入会希望日 日
            //"yoyaku_kibou__c": "required",//予約会員希望
            //"yoyaku_start__c_1": "required",//利用開始希望日 西暦
            //"yoyaku_start__c_2": "required",//利用開始希望日 月
            //"yoyaku_start__c_3": "required",//利用開始希望日 日
            //"affiliate_name__c": "required",//提携割引 提携先を選んでください
			"contact_nyukaiPack__c": "required", //ご利用希望パック
            "customer_number__c": "required",//提携割引 会員番号をお書きください
            "kenkohoken__c": "required",//健康保険に加入されていますか？
            "Field38__c": "required",//お父様の喫煙経験
            "Field39__c": "required",//お母様の喫煙経験
            "contact_syoukaiCouponNo__c": "required",//紹介者クーポンNo
            "contact_sinkiNyukiCouponNo__c": "required",//新規入会者クーポンNo
            "Field40__c": {//お父様の喫煙経験 具体的な喫煙状況をお知らせください
                "required": function () {
                    return $("#Field38__c").val() == "1"
                }
            },
            "Field41__c": {//お母様の喫煙経験 具体的な喫煙状況をお知らせください
                "required": function () {
                    return $("#Field39__c").val() == "1"
                }
            },
            "weeks_pregnancy__c": "required",//妊娠週数はどれくらいでしたか？
            "Field95__c": "required",//出生時の体重は何グラムでしたか？
            "Field96__c": "required",//出生時の異常はありましたか？ある場合は詳細をお書きください*
            "Field97__c": "required",//ある場合は詳細をお書きください
            "Field98__c": "required",//乳幼児健康診査において、要指導要観察を受けたことがありますか？
            "Field99__c": "required",//ある場合は受けた年齢・指導内容など、詳細をお書きください
            "Field100__c": "required",//喘息と診断されたことはありますか？
            "Field118__c": "required",//毎日の吸入はしていますか？
            "Field119__c": "required",//その他よく通院する特定の病気はありますか？
            "Field120__c": "required",//ある場合は詳細をお書きください
            "Field121__c": "required",//特別な医療行為を必要とする病気はありますか？
            "Field122__c": "required", //ある場合は詳細をお書きください
            "Field127__c": "required",//継続して内服している薬はありますか？
            "Field131__c": "required",//①薬名
            "Field132__c": "required",//①頻度
            // "Field133__c": "required",//②薬名
            // "Field134__c": "required",//②頻度
            // "Field135__c": "required",//③薬名
            // "Field136__c": "required",//③頻度
            "Field112__c": "required",//薬物アレルギーはありますか？
            "Field113__c": "required",//ある場合は具体的にお答えください
            "Field114__c": "required",//食物・動物アレルギーはありますか？
            "Field115__c": "required",//対象
            "Field116__c": "required",//程度
            "Field117__c": "required",//日常生活の注意点
            "Field124__c": "required",//エピペンを処方されてますか？過去に利用したことはありますか？
            "Field125__c": "required",//いつから処方されてますか？
            "Field126__c": "required",//過去に何回利用したことがありますか？
            "Field128__c": "required",//アトピー性皮膚炎と診断をうけられたことがありますか？
            "Field130__c": "required",//治療薬は
            "Field107__c": "required",//お子さまは痙攣を起こしたことがありますか？
            "Field108__c": "required",//「あり」とお答えした方にお伺いします。今まで痙攣を起こした回数は何回ですか？
            "Field109__c": "required",//受診の有無
            "Field110__c": "required",//「はい」とお答えした方にお伺いします。受診結果をお書きください
            "Field129__c": "required",//お子さまは入院されたことはありますか？
            "Field137__c": "required",//①病名
            "Field138__c": "required",//①入院期間
            "contact_umuZiko__c": "required",//特別な支援が必要な事故後遺症はありますか？
            "contact_syousaiZiko__c": "required",//特別な支援が必要な場合は詳細をお知らせください。
            "Field123__c": "required",//お子さまの健康状態で気になっていること、ノーベルの病児保育児に特に注意してほしいことなどがあればご自由にお書きください
            "account_douiTei__c": "required",//同意書のご確認
        },
        messages: {
            "Account_Name": {required: '必須項目です。'},//保護者の名前
            //"FirstName": {required: '必須項目です。'},//保護者氏名(名)
            "Contact_LastName": {required: '必須項目です。'},//お子さまの名前(姓)
            "Contact_FirstName": {required: '必須項目です。'},//お子さまの名前(名)
            "furigana2__c_LastName": {required: '必須項目です。'},//お子さまのフリガナ(セイ)
            "furigana2__c_FirstName": {required: '必須項目です。'},//お子さまのフリガナ(メイ)
            "sex__c": {required: '必須項目です。'},//お子さまの性別
            "birthday__c_1": {required: '必須項目です。'},//お子さまの生年月日 西暦
            "birthday__c_2": {required: '必須項目です。'},//お子さまの生年月日 月
            "birthday__c_3": {required: '必須項目です。'},//お子さまの生年月日 日
            "Email": {//メールアドレス
                required: '必須項目です。',
                email: '正しいemail形式で入力してください'
            },
            "Account_BillingPostalCode": {required: '必須項目です。'},//郵便番号
            "Account_BillingState": {required: '必須項目です。'},//都道府県
            "Account_BillingCity": {required: '必須項目です。'},//市区郡
            "Account_BillingStreet": {required: '必須項目です。'},//町名以下
            "Field8__c_1": {required: '必須項目です。'},//入会希望日 西暦
            "Field8__c_2": {required: '必須項目です。'},//入会希望日 月
            "Field8__c_3": {required: '必須項目です。'},//入会希望日 日
            //"yoyaku_kibou__c": {required: '必須項目です。'},//予約会員希望予約
            //"yoyaku_start__c_1": {required: '必須項目です。'},//利用開始希望日 西暦
            //"yoyaku_start__c_2": {required: '必須項目です。'},//利用開始希望日 月
            //"yoyaku_start__c_3": {required: '必須項目です。'},//利用開始希望日 日
			"contact_nyukaiPack__c": {required: '必須項目です。'}, //ご利用希望パック
            "gyoseipacki_shurui__c": {required: '必須項目です。'},//ご利用希望パック 行政パック
            "houjin_type__c": {required: '必須項目です。'},//ご利用希望パック 法人パック 勤務先企業
            "houjin_register__c": {required: '必須項目です。'},//ご利用希望パック 勤務先への申請受理済みですか
            //"affiliate_name__c": {required: '必須項目です。'},//提携割引 提携先を選んでください
            "customer_number__c": {required: '必須項目です。'},//提携割引 会員番号をお書きください
            "kenkohoken__c": {required: '必須項目です。'},//健康保険に加入されていますか？
            "contact_syoukaiCouponNo__c": {required: '必須項目です。'},//紹介者クーポンNo
            "contact_sinkiNyukiCouponNo__c": {required: '必須項目です。'},//新規入会者クーポンNo
            "Field38__c": {required: '必須項目です。'},//お父様の喫煙経験
            "Field39__c": {required: '必須項目です。'},//お母様の喫煙経験
            "Field40__c": {required: '必須項目です。'},//お父様の喫煙経験 具体的な喫煙状況をお知らせください
            "Field41__c": {required: '必須項目です。'},//お母様の喫煙経験 具体的な喫煙状況をお知らせください
            "weeks_pregnancy__c": {required: '必須項目です。'},//妊娠週数はどれくらいでしたか？
            "Field95__c": {required: '必須項目です。'},//出生時の体重は何グラムでしたか？
            "Field96__c": {required: '必須項目です。'},//出生時の異常はありましたか？ある場合は詳細をお書きください*
            "Field97__c": {required: '必須項目です。'},//ある場合は詳細をお書きください
            "Field98__c": {required: '必須項目です。'},//乳幼児健康診査において、要指導要観察を受けたことがありますか？
            "Field99__c": {required: '必須項目です。'},//ある場合は受けた年齢・指導内容など、詳細をお書きください
            "Field100__c": {required: '必須項目です。'},//喘息と診断されたことはありますか？
            "Field118__c": {required: '必須項目です。'},//毎日の吸入はしていますか？
            "Field119__c": {required: '必須項目です。'},//その他よく通院する特定の病気はありますか？
            "Field120__c": {required: '必須項目です。'},//ある場合は詳細をお書きください
            "Field121__c": {required: '必須項目です。'},//特別な医療行為を必要とする病気はありますか？
            "Field122__c": {required: '必須項目です。'}, //ある場合は詳細をお書きください
            "Field127__c": {required: '必須項目です。'},//継続して内服している薬はありますか？
            "Field131__c": {required: '必須項目です。'},//①薬名
            "Field132__c": {required: '必須項目です。'},//①頻度
            // "Field133__c": {required: '必須項目です。'},//②薬名
            // "Field134__c": {required: '必須項目です。'},//②頻度
            // "Field135__c": {required: '必須項目です。'},//③薬名
            // "Field136__c": {required: '必須項目です。'},//③頻度
            "Field112__c": {required: '必須項目です。'},//薬物アレルギーはありますか？
            "Field113__c": {required: '必須項目です。'},//ある場合は具体的にお答えください
            "Field114__c": {required: '必須項目です。'},//食物・動物アレルギーはありますか？
            "Field115__c": {required: '必須項目です。'},//対象
            "Field116__c": {required: '必須項目です。'},//程度
            "Field117__c": {required: '必須項目です。'},//日常生活の注意点
            "Field124__c": {required: '必須項目です。'},//エピペンを処方されてますか？過去に利用したことはありますか？
            "Field125__c": {required: '必須項目です。'},//いつから処方されてますか？
            "Field126__c": {required: '必須項目です。'},//過去に何回利用したことがありますか？
            "Field128__c": {required: '必須項目です。'},//アトピー性皮膚炎と診断をうけられたことがありますか？
            "Field130__c": {required: '必須項目です。'},//治療薬は
            "Field107__c": {required: '必須項目です。'},//お子さまは痙攣を起こしたことがありますか？
            "Field108__c": {required: '必須項目です。'},//「あり」とお答えした方にお伺いします。今まで痙攣を起こした回数は何回ですか？
            "Field109__c": {required: '必須項目です。'},//受診の有無
            "Field110__c": {required: '必須項目です。'},//「はい」とお答えした方にお伺いします。受診結果をお書きください
            "Field129__c": {required: '必須項目です。'},//お子さまは入院されたことはありますか？
            "Field137__c": {required: '必須項目です。'},//①病名
            "Field138__c": {required: '必須項目です。'},//①入院期間
            "contact_umuZiko__c": {required: '必須項目です。'},//特別な支援が必要な事故後遺症はありますか？
            "contact_syousaiZiko__c": {required: '必須項目です。'},//特別な支援が必要な場合は詳細をお知らせください。
            "Field123__c": {required: '必須項目です。'},//お子さまの健康状態で気になっていること、ノーベルの病児保育児に特に注意してほしいことなどがあればご自由にお書きください
            "account_douiTei__c": {required: '必須項目です。'},//同意書のご確認
        },
        errorClass: "invalid",
        errorElement: 'p',
        errorPlacement: function (error, element) {
            //checkbox
            ////予約会員希望
            //if (element.attr("name") == "yoyaku_kibou__c") {
            //    element.parents("ul").find("li:last-of-type").append("<p id='yoyaku_kibou__c-error' class='invalid'>必須項目です。</p>")
            //}
            //ご利用希望パック 法人パックの場合 勤務先への申請受理済みですか
            if (element.attr("name") == "houjin_register__c") {
                element.parents("ul").find("li:last-of-type").append("<p id='houjin_register__c-error' class='invalid'>必須項目です。</p>")
            }
            //治療薬は
            else if (element.attr("name") == "Field130__c") {
                element.parents("ul").find("li:last-of-type").append("<p id='Field130__c-error' class='invalid'>必須項目です。</p>")
            }
            //同意する
            else if (element.attr("name") == "account_douiTei__c") {
                element.parents("ul").find("li:last-of-type").append("<p id='account_douiTei__c-error' class='invalid'>必須項目です。</p>")
            }

            //radio
            //お子さまの性別
            else if (element.attr("name") == "sex__c") {
                element.parents("ul").find("li:first-of-type").append("<p id='sex__c-error' class='invalid'>必須項目です。</p>")
            }

            //selectbox
            //お子さまの生年月日
            else if (element.attr("name") == "birthday__c_1") {
                element.parents("label").after("<p id='birthday__c_1-error' class='invalid'>必須項目です。</p>")
            } else if (element.attr("name") == "birthday__c_2") {
                element.parents("label").after("<p id='birthday__c_2-error' class='invalid'>必須項目です。</p>")
            } else if (element.attr("name") == "birthday__c_3") {
                element.parents("label").after("<p id='birthday__c_3-error' class='invalid'>必須項目です。</p>")
            }
            //入会希望日
            else if (element.attr("name") == "Field8__c_1") {
                element.parents("label").after("<p id='Field8__c_1-error' class='invalid'>必須項目です。</p>")
            } else if (element.attr("name") == "Field8__c_2") {
                element.parents("label").after("<p id='Field8__c_2-error' class='invalid'>必須項目です。</p>")
            } else if (element.attr("name") == "Field8__c_3") {
                element.parents("label").after("<p id='Field8__c_3-error' class='invalid'>必須項目です。</p>")
            }
            //利用開始希望日
            //else if (element.attr("name") == "yoyaku_start__c_1") {
            //    element.parents("label").after("<p id='yoyaku_start__c_1-error' class='invalid'>必須項目です。</p>")
            //} else if (element.attr("name") == "yoyaku_start__c_2") {
            //    element.parents("label").after("<p id='yoyaku_start__c_2-error' class='invalid'>必須項目です。</p>")
            //} else if (element.attr("name") == "yoyaku_start__c_3") {
            //    element.parents("label").after("<p id='yoyaku_start__c_3-error' class='invalid'>必須項目です。</p>")
            //}
			//ご利用希望パック
			else if (element.attr("name") == "contact_nyukaiPack__c") {
				element.parents("label").after("<p id='contact_nyukaiPack__c-error' class='invalid'>必須項目です。</p>")
			}
            //ご利用希望パック 行政パック
            else if (element.attr("name") == "gyoseipacki_shurui__c") {
                element.parents("label").after("<p id='gyoseipacki_shurui__c-error' class='invalid'>必須項目です。</p>")
            }
            //ご利用希望パック 法人パック 勤務先企業
            else if (element.attr("name") == "houjin_type__c") {
                element.parents("label").after("<p id='houjin_type__c-error' class='invalid'>必須項目です。</p>")
            }
            //提携割引 利用するにチェック入ったら表示
            else if (element.attr("name") == "affiliate_name__c") {
                element.parents("label").after("<p id='affiliate_name__c-error' class='invalid'>必須項目です。</p>")
            }
            //健康保険に加入されていますか？
            else if (element.attr("name") == "kenkohoken__c") {
                element.parents("label").after("<p id='kenkohoken__c-error' class='invalid'>必須項目です。</p>")
            }
            //お父様の喫煙経験
            else if (element.attr("name") == "Field38__c") {
                element.parents("label").after("<p id='Field38__c-error' class='invalid'>必須項目です。</p>")
            }
            //お母様の喫煙経験
            else if (element.attr("name") == "Field39__c") {
                element.parents("label").after("<p id='Field39__c-error' class='invalid'>必須項目です。</p>")
            }
            //喫煙経験ありという方にお伺いします。具体的な喫煙状況をお知らせください
            else if (element.attr("name") == "kenkohoken__c") {
                element.parents("label").after("<p id='kenkohoken__c-error' class='invalid'>必須項目です。</p>")
            }
            //出生時の異常はありましたか？ある場合は詳細をお書きください*
            else if (element.attr("name") == "Field96__c") {
                element.parents("label").after("<p id='Field96__c-error' class='invalid'>必須項目です。</p>")
            }
            //乳幼児健康診査において、要指導要観察を受けたことがありますか？
            else if (element.attr("name") == "Field98__c") {
                element.parents("label").after("<p id='Field98__c-error' class='invalid'>必須項目です。</p>")
            }
            //喘息と診断されたことはありますか？
            else if (element.attr("name") == "Field100__c") {
                element.parents("label").after("<p id='Field100__c-error' class='invalid'>必須項目です。</p>")
            }
            //毎日の吸入はしていますか？
            else if (element.attr("name") == "Field118__c") {
                element.parents("label").after("<p id='Field118__c-error' class='invalid'>必須項目です。</p>")
            }
            //その他よく通院する特定の病気はありますか？
            else if (element.attr("name") == "Field119__c") {
                element.parents("label").after("<p id='Field119__c-error' class='invalid'>必須項目です。</p>")
            }
            //特別な医療行為を必要とする病気はありますか？
            else if (element.attr("name") == "Field121__c") {
                element.parents("label").after("<p id='Field121__c-error' class='invalid'>必須項目です。</p>")
            }
            //継続して内服している薬はありますか？
            else if (element.attr("name") == "Field127__c") {
                element.parents("label").after("<p id='Field127__c-error' class='invalid'>必須項目です。</p>")
            }
            //薬物アレルギーはありますか？
            else if (element.attr("name") == "Field112__c") {
                element.parents("label").after("<p id='Field112__c-error' class='invalid'>必須項目です。</p>")
            }
            //食物・動物アレルギーはありますか？
            else if (element.attr("name") == "Field114__c") {
                element.parents("label").after("<p id='Field114__c-error' class='invalid'>必須項目です。</p>")
            }
            //エピペンを処方されてますか？過去に利用したことはありますか？
            else if (element.attr("name") == "Field124__c") {
                element.parents("label").after("<p id='Field124__c-error' class='invalid'>必須項目です。</p>")
            }
            //アトピー性皮膚炎と診断をうけられたことがありますか？
            else if (element.attr("name") == "Field128__c") {
                element.parents("label").after("<p id='Field128__c-error' class='invalid'>必須項目です。</p>")
            }
            //お子さまは痙攣を起こしたことがありますか？
            else if (element.attr("name") == "Field107__c") {
                element.parents("label").after("<p id='Field107__c-error' class='invalid'>必須項目です。</p>")
            }
            //受診の有無
            else if (element.attr("name") == "Field109__c") {
                element.parents("label").after("<p id='Field109__c-error' class='invalid'>必須項目です。</p>")
            }
            //お子さまは入院されたことはありますか？
            else if (element.attr("name") == "Field129__c") {
                element.parents("label").after("<p id='Field129__c-error' class='invalid'>必須項目です。</p>")
            }
            //特別な支援が必要な事故後遺症はありますか？
            else if (element.attr("name") == "contact_umuZiko__c") {
                element.parents("label").after("<p id='contact_umuZiko__c-error' class='invalid'>必須項目です。</p>")
            }

            //その他
            else {
                error.insertAfter(element);
            }
        },
        onfocusout: function (element) {
            $(element).valid();
        }
    });

    $("#form_contact_detail_1").validate({
        //checkbox、radioボタンはidをignoreに入れる必要あり。
        ignore: ':hidden:not("#Field53__c_1,#Field53__c_2,#AED__c_1,#AED__c_2,#Field277__c_1,#Field277__c_2")',
        rules: {
            "Field89__c": "required",//お子さまの愛称
            "Field92__c": "required",//保育園・学校名
            "Field94__c": "required",//保育園・学校 住所
            "aaa_c": "required",//医院名①
            "Field147__c": "required",//医院名① 住所
            "Field165__c": "required",//医院①までの距離(徒歩)
            "Field155__c": "required",//医院名②
            "Field156__c": "required",//医院② 住所
            "Field164__c": "required",//医院②までの距離(徒歩)
            "dad_firstname_kana__c": "required",//保護者名(父)
            "Field63__c": "required",//保護者名(父)ふりがな
            "dad_company__c": "required",//【父】勤務先
            "Field69__c": "required",//【父】勤務先・連絡先
            "dad_cellphone__c": "required",//【父】携帯電話
            "mom_lastname__c": "required",//保護者名(母)
            "Field67__c": "required",//保護者名(母)ふりがな
            "mom_company__c": "required",//【母】勤務先
            "Field70__c": "required",//【母】勤務先・連絡先
            "mom_cellphone__c": "required",//【母】携帯電話
            "Field53__c": "required",//【有無】ペット
            "Field54__c": "required",//【詳細】ペット
            "Field59__c": "required",//【道順】最寄り駅
            "Field60__c": "required",//【道順】最寄り駅出口
            "Field61__c": "required",//【道順】最寄からの距離
            "Field62__c": "required",//【道順】最寄からの行き方
            "Field57__c": "required",//【自宅】セキュリティ特記事項
            "AED__c": "required",//【有無】AED
            "Field58__c": "required",//【有無】駐輪場
            "Field71__c": "required",//駐輪場の詳細
            "Field55__c": "required",//【自宅】避難場所
            "Field56__c": "required",//【自宅】避難住所
        },
        messages: {
            "Field89__c": {required: '必須項目です。'},
            "Field92__c": {required: '必須項目です。'},//保育園・学校名
            "Field94__c": {required: '必須項目です。'},//保育園・学校 住所
            "aaa_c": {required: '必須項目です。'},//医院名①
            "Field147__c": {required: '必須項目です。'},//医院名① 住所
            "Field165__c": {required: '必須項目です。'},//医院①までの距離(徒歩)
            "Field155__c": {required: '必須項目です。'},//医院名②
            "Field156__c": {required: '必須項目です。'},//医院② 住所
            "Field164__c": {required: '必須項目です。'},//医院②までの距離(徒歩)
            "dad_firstname_kana__c": {required: '必須項目です。'},//保護者名(父)
            "Field63__c": {required: '必須項目です。'},//保護者名(父)ふりがな
            "dad_company__c": {required: '必須項目です。'},//【父】勤務先
            "Field69__c": {required: '必須項目です。'},//【父】勤務先・連絡先
            "dad_cellphone__c": {required: '必須項目です。'},//【父】携帯電話
            "mom_lastname__c": {required: '必須項目です。'},//保護者名(母)
            "Field67__c": {required: '必須項目です。'},//保護者名(母)ふりがな
            "mom_company__c": {required: '必須項目です。'},//【母】勤務先
            "Field70__c": {required: '必須項目です。'},//【母】勤務先・連絡先
            "mom_cellphone__c": {required: '必須項目です。'},//【母】携帯電話
            "Field53__c": {required: '必須項目です。'},//【有無】ペット
            "Field54__c": {required: '必須項目です。'},//【詳細】ペット
            "Field59__c": {required: '必須項目です。'},//【道順】最寄り駅
            "Field60__c": {required: '必須項目です。'},//【道順】最寄り駅出口
            "Field61__c": {required: '必須項目です。'},//【道順】最寄からの距離
            "Field62__c": {required: '必須項目です。'},//【道順】最寄からの行き方
            "Field57__c": {required: '必須項目です。'},//【自宅】セキュリティ特記事項
            "AED__c": {required: '必須項目です。'},//【有無】AED
            "Field58__c": {required: '必須項目です。'},//【有無】駐輪場
            "Field71__c": {required: '必須項目です。'},//駐輪場の詳細
            "Field55__c": {required: '必須項目です。'},//【自宅】避難場所
            "Field56__c": {required: '必須項目です。'},//【自宅】避難住所
        },
        errorClass: "invalid",
        errorElement: 'p',
        errorPlacement: function (error, element) {
            //radio
            //ペット
            if (element.attr("name") == "Field53__c") {
                element.parents("ul").find("li:first-of-type").append("<p id='sex__c-error' class='invalid'>必須項目です。</p>")
            }
            //AED
            else if (element.attr("name") == "AED__c") {
                element.parents("ul").find("li:first-of-type").append("<p id='sex__c-error' class='invalid'>必須項目です。</p>")
            }
            //駐輪場
            else if (element.attr("name") == "Field277__c") {
                element.parents("ul").find("li:first-of-type").append("<p id='sex__c-error' class='invalid'>必須項目です。</p>")
            }

            //その他
            else {
                error.insertAfter(element);
            }
        },
        onfocusout: function (element) {
            $(element).valid();
        }
    });

	//フォームの2通し禁止
	$("form").submit(function() {
		//エラーの表示があるか
		isError = false;
		$('p.invalid').each(function(i, elem){
			if($(elem).css('display') == 'block') isError = true;
		});

		//エラーがなければ
		if(!isError) {
			var self = this;
			$(":submit", self).prop("disabled", true);
			setTimeout(function () {
				$(":submit", self).prop("disabled", false);
			}, 30000);
		}
	});



//jQuery.extend(jQuery.validator.messages, {
//    required: "必須項目です",
//    maxlength: jQuery.format("{0} 文字以下を入力してください"),
//    minlength: jQuery.format("{0} 文字以上を入力してください"),
//    rangelength: jQuery.format("{0} 文字以上 {1} 文字以下で入力してください"),
//    email: "メールアドレスを入力してください",
//    url: "URLを入力してください",
//    dateISO: "日付を入力してください",
//    number: "有効な数字を入力してください",
//    digits: "0-9までを入力してください",
//    equalTo: "同じ値を入力してください",
//    range: jQuery.format(" {0} から {1} までの値を入力してください"),
//    max: jQuery.format("{0} 以下の値を入力してください"),
//    min: jQuery.format("{0} 以上の値を入力してください"),
//    creditcard: "クレジットカード番号を入力してください"
//});
//jQuery.validator.addMethod('required', function (value) {
//    return (value != '0');
//}, "year required");
})
;
